import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { Divider } from '@material-ui/core'
import {styles} from '../../CSS/Styles'
import TextField from '@material-ui/core/TextField'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import SimpleSelect from '../../CSSComponent/dropdownselection'
import Checkbox from '@material-ui/core/Checkbox'
import Button from '@material-ui/core/Button'
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  overrides: {
    MuiInput: {
      underline: {
        "&&&&:before": {
            borderBottom: "0px solid rgba(0, 0, 0, 0)"
        },
        "&&&&:hover:before": {
          borderBottom: "0px solid rgba(0, 0, 0, 0)"
        }
      }
    }
  }
});

class Controls extends React.Component {

    constructor(props) {
        super(props)
        let ControlNo = []
        let ControlDescription = []
        let ControlOwner = []
        let ControlFrequency = []
        let ControlNETS = []
        let ControlBCS = []
        let ControlBCSIS = []
        let ControlStrength = []
        let ControlRCSA = []
        let ControlIA = []
        let ControlOthers = []
        for (let itemindex in this.props.control) {
            let item = this.props.control[itemindex]
            ControlNo.push(item.control_no)
            ControlDescription.push(item.summary_of_controls)
            ControlOwner.push(item.control_owner)
            ControlFrequency.push(item.frequency)
            ControlNETS.push(item.NETS)
            ControlBCS.push(item.BCS)
            ControlBCSIS.push(item.BCSIS)
            ControlStrength.push(item.control_strength)
            ControlRCSA.push(item.RCSA)
            ControlIA.push(item.IA)
            ControlOthers.push(item.others)
        }
        this.state = {
            'control':this.props.control,
            'ControlNo': ControlNo,
            'ControlDescription': ControlDescription,
            'ControlOwner': ControlOwner,
            'ControlFrequency': ControlFrequency,
            'ControlNETS': ControlNETS,
            'ControlBCS': ControlBCS,
            'ControlBCSIS': ControlBCSIS,
            'ControlStrength': ControlStrength,
            'ControlRCSA': ControlRCSA,
            'ControlIA': ControlIA,
            'ControlOthers': ControlOthers,
        }
    }

    componentDidUpdate(prevProps) {
        // console.log("new id : " + this.props.queryID + "vs old id : " + prevProps.queryID);
        if (this.props != prevProps) {
            console.log("peops changede")
            let ControlNo = []
            let ControlDescription = []
            let ControlOwner = []
            let ControlFrequency = []
            let ControlNETS = []
            let ControlBCS = []
            let ControlBCSIS = []
            let ControlStrength = []
            let ControlRCSA = []
            let ControlIA = []
            let ControlOthers = []
            for (let itemindex in this.props.control) {
                let item = this.props.control[itemindex]
                ControlNo.push(item.control_no)
                ControlDescription.push(item.summary_of_controls)
                ControlOwner.push(item.control_owner)
                ControlFrequency.push(item.frequency)
                ControlNETS.push(item.NETS)
                ControlBCS.push(item.BCS)
                ControlBCSIS.push(item.BCSIS)
                ControlStrength.push(item.control_strength)
                ControlRCSA.push(item.RCSA)
                ControlIA.push(item.IA)
                ControlOthers.push(item.others)
            }
            this.setState({
                'control':this.props.control,
                'ControlNo': ControlNo,
                'ControlDescription': ControlDescription,
                'ControlOwner': ControlOwner,
                'ControlFrequency': ControlFrequency,
                'ControlNETS': ControlNETS,
                'ControlBCS': ControlBCS,
                'ControlBCSIS': ControlBCSIS,
                'ControlStrength': ControlStrength,
                'ControlRCSA': ControlRCSA,
                'ControlIA': ControlIA,
                'ControlOthers': ControlOthers,
            })
        }
    }
    handleChange = (name, index) => event => {
        let newdata = this.state[name]
        newdata[index] = (event.target.checked ? '✔' : null)
        this.setState({ [name]: newdata },()=>{
            this.props.submitChange(name, this.state[name])
        })
        //console.log(name)
    };

    handleListSelect = (key, value, index) => {
        this.setState((state)=>{ this.state[key][index] = value }, ()=>{
            this.props.submitChange(key, this.state[key])
        })
    };




    handleTextChange = (name, index, event) => {
        //console.log(this.Risk_info_temp)
        let value = event.target.value
        this.setState((state)=>{ 
            this.state[name][index] = value
            this.props.submitChange(name, this.state[name])
        })
        this.forceUpdate()
    };

    handleAddNew = (event) => {

        let updateList = this.state.control

        updateList.push("")

        this.setState({control: updateList}, ()=>{
            this.props.submitChange('control', updateList)
        })
    };

    handleDrop = (event) => {

        let index = event.target.parentNode.dataset.index
        // if click on the border of the button, it returns the parents........
        if (index == null) {
            index = event.target.dataset.index
        }

        let updateListcontrol = this.state.control
        let updateListControlNo = this.state.ControlNo
        let updateListControlDescription = this.state.ControlDescription
        let updateListControlOwner = this.state.ControlOwner
        let updateListControlFrequency = this.state.ControlFrequency
        let updateListControlNETS = this.state.ControlNETS
        let updateListControlBCS = this.state.ControlBCS
        let updateListControlBCSIS = this.state.ControlBCSIS
        let updateListControlStrength = this.state.ControlStrength
        let updateListControlRCSA = this.state.ControlRCSA
        let updateListControlIA = this.state.ControlIA
        let updateListControlOthers = this.state.ControlOthers

        updateListcontrol.splice(index, 1)
        updateListControlNo.splice(index, 1)
        updateListControlDescription.splice(index, 1)
        updateListControlOwner.splice(index, 1)
        updateListControlFrequency.splice(index, 1)
        updateListControlNETS.splice(index, 1)
        updateListControlBCS.splice(index, 1)
        updateListControlBCSIS.splice(index, 1)
        updateListControlStrength.splice(index, 1)
        updateListControlRCSA.splice(index, 1)
        updateListControlIA.splice(index, 1)
        updateListControlOthers.splice(index, 1)

        this.setState({
            control: updateListcontrol,
            ControlNo: updateListControlNo,
            ControlDescription: updateListControlDescription,
            ControlOwner: updateListControlOwner,
            ControlFrequency: updateListControlFrequency,
            ControlNETS: updateListControlNETS,
            ControlBCS: updateListControlBCS,
            ControlBCSIS: updateListControlBCSIS,
            ControlStrength: updateListControlStrength,
            ControlRCSA: updateListControlRCSA,
            ControlIA: updateListControlIA,
            ControlOthers: updateListControlOthers
        }, ()=>{
            this.props.submitChange('ControlNo', updateListControlNo)
            this.props.submitChange('ControlDescription', updateListControlDescription)
            this.props.submitChange('ControlOwner', updateListControlOwner)
            this.props.submitChange('ControlFrequency', updateListControlFrequency)
            this.props.submitChange('ControlNETS', updateListControlNETS)
            this.props.submitChange('ControlBCS', updateListControlBCS)
            this.props.submitChange('ControlBCSIS', updateListControlBCSIS)
            this.props.submitChange('ControlStrength', updateListControlStrength)
            this.props.submitChange('ControlRCSA', updateListControlRCSA)
            this.props.submitChange('ControlIA', updateListControlIA)
            this.props.submitChange('ControlOthers', updateListControlOthers)
        })
    }

    render() {
        const { classes } = this.props;
        let namelist = []
        for (let list in this.props.employee) {
            namelist.push(this.props.employee[list].name + ', ' + this.props.employee[list].designation)
        }
        let frequency = ['Annually', 'Monthly', 'Daily']
        let controlstrengh = ['Strong', 'Moderate', 'Weak']

        const ExistingControlsTable =  (
            <div>
                <Table padding='dense'>
                    <TableHead>
                        <TableRow style={{height:'40px'}}>
    
                            <TableCell align = 'center' rowSpan={2} > No </TableCell>
                            <TableCell align = 'center' rowSpan={2} > Description </TableCell>
                            <TableCell align = 'center' rowSpan={2} > Control Owner</TableCell>
                            <TableCell align = 'center' rowSpan={2} > Freq </TableCell>
                            <TableCell align = 'center' colSpan={3} > Aoolicable Entitles </TableCell>
                            <TableCell align = 'center' rowSpan={2} > Control Strength</TableCell>
                            <TableCell align = 'center' colSpan={3} > Sources of Assurance </TableCell>
                        </TableRow>
                        <TableRow style={{height:'40px'}}>
                            <TableCell align = 'center' rowSpan={2} style={{ whiteSpace: 'nowrap',  padding: '10px 2px 10px 2px' }}> ABC </TableCell>
                            <TableCell align = 'center' rowSpan={2} style={{ whiteSpace: 'nowrap',  padding: '10px 2px 10px 2px' }}> ABB </TableCell>            
                            <TableCell align = 'center' rowSpan={2} style={{ whiteSpace: 'nowrap',  padding: '10px 2px 10px 2px' }}> ACC </TableCell>      
                            <TableCell align = 'center' rowSpan={2} style={{ whiteSpace: 'nowrap',  padding: '10px 2px 10px 2px' }}> CSA </TableCell>
                            <TableCell align = 'center' rowSpan={2} style={{ whiteSpace: 'nowrap',  padding: '10px 2px 10px 2px' }}> IA </TableCell>            
                            <TableCell align = 'center' rowSpan={2} style={{ whiteSpace: 'nowrap',  padding: '10px 2px 10px 2px' }}> Others </TableCell>     
                        </TableRow>
                    </TableHead>
                    
                    <TableBody>
                        {this.state.control.map((controlitem, index)=>{
                            //console.log(this.state.control)
                            return(
                                <TableRow style={{height:'40px'}}>
                                    <TableCell align = 'center' style={{ width:'1%', padding: '10px 2px 10px 2px' }}>
                                        <TextField
                                            id = "ControlNo"
                                            InputProps={{ style: { fontSize: 15 }}}
                                            inputProps={{ style: { textAlign: "center" }}}
                                            onChange = {(event) => this.handleTextChange("ControlNo", index, event)}
                                            value = {this.state.ControlNo[index]}
                                            placeholder = "C1"
                                        />
                                        <Button
                                            data-index={index}
                                            variant='outlined'
                                            color='secondary'
                                            className={classes.button}
                                            onClick= {this.handleDrop}
                                        >
                                            Drop
                                        </Button>
                                    </TableCell>
                                    <TableCell align = 'center' style={{padding: '10px 2px 10px 2px' }}>
                                        <TextField
                                            style= {{width: '16vw'}}
                                            margin='dense'
                                            id = "ControlDescription"
                                            className={classes.TextFieldUnderline}
                                            InputProps={{ style: { fontSize: 15 }}}
                                            inputProps={{ style: {overflow: "hidden" }}}
                                            multiline = {true}
                                            onChange = {(event) => this.handleTextChange("ControlDescription", index, event)}
                                            value = {this.state.ControlDescription[index]}
                                            placeholder = "Description"
                                        /> </TableCell>
                                    <TableCell align = 'center' style={{ padding: '10px 2px 10px 2px' }}> 
                                        <SimpleSelect index={index} id = 'ControlOwner' option = {namelist} defaultoption={namelist.findIndex(item => item == this.state.ControlOwner[index])} returnSelection={this.handleListSelect}/> 
                                    </TableCell>
                                    <TableCell align = 'center' style={{ padding: '10px 2px 10px 2px' }}> 
                                        <SimpleSelect index={index} id = 'ControlFrequency' option = {frequency} defaultoption={frequency.findIndex(item => item == this.state.ControlFrequency[index])} returnSelection={this.handleListSelect}/>  
                                    </TableCell>
                                    {['ControlNETS','ControlBCS','ControlBCSIS'].map((data)=>{return(
                                        <TableCell align = 'center' style={{ width:'1%', padding: '10px 2px 10px 2px' }}> 
                                            <Checkbox
                                                style={{ padding: '0px' }}
                                                checked={this.state[data][index]}
                                                onChange={this.handleChange(data, index)}
                                                value={data}
                                                color='primary'
                                            />
                                        </TableCell>
                                    )})}
                                    <TableCell align = 'center' style={{ padding: '10px 2px 10px 2px' }}> 
                                        <SimpleSelect index={index} id = 'ControlStrength' option = {controlstrengh}  defaultoption={controlstrengh.findIndex(item => item == this.state.ControlStrength[index])} returnSelection={this.handleListSelect}/>
                                    </TableCell>
                                    {['ControlRCSA','ControlIA','ControlOthers'].map((data)=>{return(
                                        <TableCell align = 'center' style={{ width:'1%', padding: '10px 2px 10px 2px' }}>
                                            <Checkbox
                                                style={{ padding: '0px' }}
                                                checked={this.state[data][index]}
                                                onChange={this.handleChange(data, index)}
                                                value={data}
                                                color='primary'
                                            />
                                        </TableCell>
                                    )})}
                                </TableRow>
                            )
                        })}
                    </TableBody>
    
                </Table>
                <div className={classes.button_table_add_neww}>
                    <Button variant="outlined" color="primary" className={classes.button} onClick= {this.handleAddNew}>
                        Add New
                    </Button>
                </div>
            </div>
        )

        return(
            <MuiThemeProvider theme={theme}>
                <div>
                    <Typography variant = "h6"  align="left" className={classes.FormHeader}> D. Existing Controls </Typography>
                    <Divider className={classes.FormDivider}/>
                    {ExistingControlsTable}
                </div>
            </MuiThemeProvider>
                    
        )
    }
}

export default withStyles(styles)(Controls);
    


// WEBPACK FOOTER //
// ./src/components/Risks/RiskRegisterSection/D.js